import { fetchData } from "./fetch";

export const getNotifications = (data) => fetchData('GET', '/notifications', data);
